/**
 * Best Sellers — tabs + drag-to-scroll rail + progress bar + nav arrows.
 * All three layouts (v1/v2/v3) share the same DOM; only card width and
 * rail gap differ. One init handles all three.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-bestsellers-root]');
  if (!root) return;

  var tabs = root.querySelectorAll('.bestsellers-tab');
  var carousels = root.querySelectorAll('.bestsellers-scroll');
  var progressBar = document.getElementById('bestsellers-progress');
  var prevBtn = root.querySelector('.bestsellers-nav-prev');
  var nextBtn = root.querySelector('.bestsellers-nav-next');
  var activeTab = 'best-sellers';

  function getActiveCarousel() {
    for (var i = 0; i < carousels.length; i++) {
      if (carousels[i].getAttribute('data-carousel') === activeTab) return carousels[i];
    }
    return null;
  }

  // Tab switching
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab');
      if (target === activeTab) return;
      activeTab = target;

      tabs.forEach(function (t) {
        var line = t.querySelector('.bestsellers-tab-line');
        if (t.getAttribute('data-tab') === activeTab) {
          t.classList.remove('text-brand-text-muted');
          t.classList.add('text-foreground');
          if (line) line.classList.remove('hidden');
        } else {
          t.classList.remove('text-foreground');
          t.classList.add('text-brand-text-muted');
          if (line) line.classList.add('hidden');
        }
      });

      carousels.forEach(function (c) {
        if (c.getAttribute('data-carousel') === activeTab) {
          c.classList.remove('hidden');
          c.scrollLeft = 0;
          updateProgress(c);
        } else {
          c.classList.add('hidden');
        }
      });
    });
  });

  // Progress bar
  function updateProgress(el) {
    if (!el || !progressBar) return;
    var max = el.scrollWidth - el.clientWidth;
    var pct = max > 0 ? (el.scrollLeft / max) * 100 : 0;
    progressBar.style.width = Math.max(20, pct) + '%';
  }

  carousels.forEach(function (c) {
    var ticking = false;
    c.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          if (!c.classList.contains('hidden')) updateProgress(c);
          ticking = false;
        });
      }
    }, { passive: true });
  });

  // Nav arrows — scroll active rail by one card width
  function scrollCarousel(dir) {
    var c = getActiveCarousel();
    if (!c) return;
    var card = c.querySelector('.snap-start');
    var amount = card ? card.offsetWidth + 16 : 300;
    c.scrollBy({ left: dir === 'prev' ? -amount : amount, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { scrollCarousel('prev'); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollCarousel('next'); });

  // Drag-to-scroll
  carousels.forEach(function (c) {
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;

    c.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX;
      startScrollLeft = c.scrollLeft;
      c.classList.remove('cursor-grab');
      c.classList.add('cursor-grabbing', 'select-none');
    });

    c.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var dx = e.pageX - startX;
      c.scrollLeft = startScrollLeft - dx;
    });

    function stopDrag() {
      if (!isDragging) return;
      isDragging = false;
      c.classList.remove('cursor-grabbing', 'select-none');
      c.classList.add('cursor-grab');
    }

    c.addEventListener('mouseup', stopDrag);
    c.addEventListener('mouseleave', stopDrag);

    c.addEventListener('click', function (e) {
      if (Math.abs(e.pageX - startX) > 5) e.preventDefault();
    }, true);
  });
})();
